import React from 'react';
import { DH } from '../../utils/DataHook';
import { t } from '../../utils/i18n';
import { Button } from '../Button';
import { Loader } from '../Loader';
import * as s from './styles.scss';

export const PayButtonView: React.FunctionComponent<{
  text: string;
  isLoading: boolean;
  isDisabled: boolean;

  onClick(): void;
}> = ({
  text = 'form.submit',
  isLoading = false,
  isDisabled = false,
  onClick = () => null,
}) => (
  <Button
    disabled={isDisabled}
    dataHook={DH.PayButton.Button}
    size="large"
    filled
    fullWidth
    onClick={onClick}
  >
    {isLoading ? (
      <span className={s.spinnerWrap}>
        <Loader
          size="small"
          color="white"
          isExpanded={false}
          dataHook={DH.PayButton.Loader}
        />
      </span>
    ) : (
      t(text)
    )}
  </Button>
);
PayButtonView.displayName = 'PayButtonView';
